import api from "./api";

interface LoginResponse {
  access_token: string;
  user: {
    id: number;
    username: string;
  };
}

export const authService = {
  async login(username: string, password: string): Promise<LoginResponse> {
    const response = await api.post("/auth/login", { username, password });
    return response.data;
  },

  async register(username: string, password: string): Promise<any> {
    const response = await api.post("/auth/register", { username, password });
    return response.data;
  },
};
